// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Gz-z","disabled":"Hz-z","wrapper":"Iz-z","mProduct":"Jz-z","image":"Kz-z","itemContainer":"Lz-z","productName":"Mz-z","itemDetails":"Nz-z"};